import { Controller } from "stimulus";
import { useDispatch } from 'stimulus-use';

import { loadImageFromFile } from '../../lib/images';

export default class extends Controller {
  static targets = ['file', 'cropbox', 'message', 'signedId'];

  static values = {
    errorMessage: String,
    loadingMessage: String
  };

  connect() {
    useDispatch(this);
  }

  async preview() {
    const [ file ] = this.fileTarget.files;

    this.messageTarget.innerText = this.loadingMessageValue;

    try {
      const imgSrc = await loadImageFromFile(file, { max: 1200 });

      this.cropboxTarget.src = imgSrc;
      this.dispatch('file-selected', { filename: file.name });

    } catch(err) {
      this.messageTarget.innerText = this.errorMessageValue;
    }
  }

  reset() {
    this.messageTarget.innerText = '';
    this.fileTarget.value = '';
  }

  update(ev) {
    if (ev.detail.attachment.signed_id) {
      this.signedIdTarget.value = ev.detail.attachment.signed_id;
      this.signedIdTarget.disabled = false;

      const form = this.signedIdTarget.form;

      if (form) {
        form.dispatchEvent(new CustomEvent('submit', { bubbles: true }));
      }
    }
  }
}
